import { useEffect } from 'react';

import { loadGooglePaySdk } from '../../services/googlepay/utils';

const ScriptContainer = () => {
    useEffect(() => {
        loadGooglePaySdk().catch(error => console.error(error));
        initApplePayTagScript();
    }, []);

    const initApplePayTagScript = () => {
        if (document.getElementById('apple-pay-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'apple-pay-sdk';
        script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
        script.async = true;
        document.head.appendChild(script);
    };

    return null;
};

export default ScriptContainer;



// WEBPACK FOOTER //
// ./src/components/funnel/ScriptContainer.js